import { EventEmitter } from "./utils/EventEmitter";
export class ExperienceUI extends EventEmitter {
  constructor() {
    super();
    this.input = document.getElementById("search");
    this.suggestions = document.getElementById("suggestions");
    this.timeout = undefined;
    this.track = undefined;

    this.setDefaultTracks();
    this.addEventListeners();
  }

  setDefaultTracks() {
    const defaultTracks = [
      {
        title: "Bites the dust bng",
        artist: "BNG",
        cover: "bites_the_dust.jpg",
        file: "bites_the_dust.mp3",
      },
      {
        title: "abysses neophron",
        artist: "neophron",
        cover: "neophron.jpg",
        file: "abysses.mp3",
      },
      {
        title: "Ne me parle plus notinbed",
        artist: "Timothée Joly, notinbed",
        cover: "notinbed.jpg",
        file: "ne_me_parles_plus.mp3",
      },
    ];

    const defaultContainer = document.getElementById("default-tracks");

    defaultTracks.forEach((track) => {
      const el = document.createElement("div");
      el.classList.add("default-track");

      let title = track.title.split(" ");
      title.pop();
      title = title.join(" ");
      el.innerHTML = `
    <img src="${track.cover}" alt="${title}">
    <span>${title}</span>
    <span style="color:#aaa">${track.artist}</span>
  `;

      el.addEventListener("click", () => {
        // ici on émet un event ou on appelle directement la fonction pour sélectionner la track
        this.track = {
          title: track.title,
          artist: { name: track.artist },
          file: `${track.file}`,
          cover: `${track.cover}`,
        };

        this.emit("trackSelected", this.track);
      });

      defaultContainer.appendChild(el);
    });
  }

  addEventListeners() {
    this.input.addEventListener("input", () => {
      clearTimeout(this.timeout);
      const query = this.input.value.trim();
      if (!query) {
        this.suggestions.innerHTML = "";
        return;
      }

      this.timeout = setTimeout(() => this.searchDeezer(query), 500);
    });
  }

  displayResults(tracks) {
    this.suggestions.style.display = "inline";
    this.suggestions.innerHTML = tracks
      .slice(0, 5)
      .map(
        (t) => `
        <li data-id="${t.id}">
          <img src="${t.album.cover_small}" alt="">
          <div class="info">
            <span class="title">${t.title}</span>
            <span class="artist">${t.artist.name}</span>
          </div>
        </li>`,
      )
      .join("");
    document.querySelectorAll("#suggestions li").forEach((li) => {
      li.addEventListener("click", () => {
        this.suggestions.style.display = "none";
        const id = li.getAttribute("data-id");
        this.track = tracks.find((t) => t.id == id);
        this.input.value = `${this.track.title} – ${this.track.artist.name}`;
        this.suggestions.innerHTML = "";
        this.emit("trackSelected", this.track);
      });
    });
  }

  searchDeezer(query, autoSelect = false) {
    const script = document.createElement("script");
    const callback =
      "deezerCallback_" + Math.random().toString(36).substr(2, 9);
    script.src = `https://api.deezer.com/search?q=${encodeURIComponent(
      query,
    )}&output=jsonp&callback=${callback}`;
    window[callback] = (response) => {
      const tracks = response.data || [];
      if (autoSelect && tracks.length > 0) {
        // prend le premier résultat
        this.track = tracks[0];
        this.input.value = `${this.track.title} – ${this.track.artist.name}`;
        this.emit("trackSelected", this.track);
      } else {
        this.displayResults(tracks);
      }
      document.body.removeChild(script);
      delete window[callback];
    };
    document.body.appendChild(script);
  }
}
